import React from 'react'
import InlineSpinner from './inline-spinner'
import ResetButton from './reset-button'
import { Control, UseFormRegister } from 'react-hook-form'
import { T2EFormData } from 'hooks/useTranslationForm'

type Props = {
   placeholder: string
   isLoading: boolean
   reset: () => void
   control: Control<T2EFormData>
   register: UseFormRegister<T2EFormData>
}

const TranslationTextarea: React.FC<Props> = ({
   isLoading,
   placeholder,
   register,
   control,
   reset,
}) => {
   return (
      <div className="relative">
         <textarea
            className="mx-auto block w-full px-6 py-5 mb-6 shadow-sm rounded-2xl border border-gray-200 bg-white outline-none focus:border-lightBlue placeholder-gray-400 placeholder:text-[14px] placeholder:leading-[1.7] md:placeholder:text-[16px] md:placeholder:leading-[1.8] h-[104px] transition-colors duration-300"
            placeholder={placeholder}
            aria-label="searchbox"
            data-gramm="false"
            {...register('sourceText')}
         />
         <ResetButton control={control} reset={reset} />

         {isLoading && (
            <div className="absolute bottom-6 right-6">
               <InlineSpinner />
            </div>
         )}
      </div>
   )
}

export default TranslationTextarea
